import * as THREE from 'three';
import gsap from 'gsap';
import { LogoMarkStrokes } from './LogoMarkStrokes';
import { MojisLines } from '../MojisLines';
import { LogoMark } from './LogoMark';
import { LogoMarkMesh } from './LogoMarkMesh';
import { MojiDot } from '../MojiDot';
import { MojiPointsUtil } from '../utils/MojiPointsUtil';


export class LogoMarkControl0{

    strokes     : LogoMarkStrokes;
    mojis       : MojisLines;
    logo    :LogoMark;
    logoMesh: LogoMarkMesh;
    currentDot: MojiDot;
    
    count:number=0;
    logoCount:number=0;
    bgCount:number=0;

    logoDots:MojiDot[];
    bgDots:MojiDot[];

    isInit:boolean=false;
    isShowing:boolean=false;
    enabled:boolean=false;

    callbackShow:()=>void;
    callbackHide:()=>void;

    //ロゴ表示
    public Show(callback:()=>void){
        this.callbackShow=callback;
        this.enabled=true;
        this.showLogoDots();
    }

    //ロゴを出す
    private showLogoDots(){
        this.isShowing=true;
        this.resetBaseDots(true);
        this.resetCount();
        this.count=0;
        gsap.to(this,{
            count: this.logoDots.length,
            duration: 8,
            ease: "power3.inOut"
        });
        gsap.delayedCall(8,()=>{
            this.showFillLogo();
            this.callbackShow();
        })
    }

    //ロゴ（塗り）を出す
    private showFillLogo(){   
        this.isShowing=true;     
        this.count=0;
        this.logo.showFillLogo();
        this.logoMesh.hideAllDots();
    }

    resetBaseDots(isAll:boolean){

        this.bgDots = isAll ? this.mojis.getAllDots() : this.mojis.getAllEnabledDots();//全ドットを取得
        this.logoDots = this.logoMesh.updateAllDots();

        console.log("bgDots="+this.bgDots.length);
        console.log("logoDots="+this.logoDots.length);

        this.bgDots     = MojiPointsUtil.RandomArray(this.bgDots);//ランダマイズ
        this.logoDots   = MojiPointsUtil.RandomArray(this.logoDots);

        for(let i=0;i<this.logoDots.length;i++){
            this.logoDots[i].tgtIndex=[];
        }

        let len = Math.max( this.bgDots.length,this.logoDots.length );
        for(let i=0;i<len;i++){
            this.logoDots[i%this.logoDots.length].tgtIndex.push(i%this.bgDots.length);
        }
        //for(let i=0;i<this.bgDots.length;i++){
        //    this.bgDots[i].tgtIndex.push(i%this.logoDots.length);
        //}

    }

    resetCount(){

        for(let i=0;i<this.logoDots.length;i++){
            this.logoDots[i].count=0;  
        }
        //
        for(let i=0;i<this.bgDots.length;i++){
            this.bgDots[i].count=0;
        }        

    }

    setBgDotsEnabled(b:boolean){
        for(let i=0;i<this.bgDots.length;i++){
            this.bgDots[i].enabled=b;
        }    
    }

    setLogoDotsEnabled(b:boolean){
        for(let i=0;i<this.logoDots.length;i++){
            this.logoDots[i].enabled=b;
        }    
    }

    //ロゴの表示
    updateShowLogoDots(){
        if(this.count==0)return;

        //bgdotの数
        let bgDotCount=0;
        for(let i=0;i<this.bgDots.length;i++){
            if(this.bgDots[i].enabled)bgDotCount++;
        }

        //console.log(bgDotCount)

        for(let i=0;i<this.count;i++){
            let logoDot = this.logoDots[i];//ロゴドットを主役にする。

            if(logoDot){
                let len = logoDot.tgtIndex.length;
                for(let j=0;j<len;j++){//ロゴドットにリンクされてるbgを対象に
                    
                    let bgDot = this.bgDots[ logoDot.tgtIndex[j] ];
                    
                    if(bgDot.enabled){
                        let limit = 10+10*Math.random();
                        this.strokes.connectDots(
                            bgDot.v.x,bgDot.v.y,bgDot.v.y,
                            logoDot.v.x,logoDot.v.y,logoDot.v.z,
                            1-bgDot.count/limit
                        );
                        bgDot.count++;
                        if(bgDot.count>limit){
                            bgDot.enabled=false;
                        }

                        if(!logoDot.enabled)logoDot.scale=1.8;
                        logoDot.enabled=true;
                    }
                    
                }
            }
        }
        

    }


}


